<template>
  <div>
    <el-form
      :model="form"
      status-icon
      ref="form"
      label-width="100px"
      class="apk-form"
      :rules="formRules"
    >
      <template v-for="f in eidtableFormItems">
        <el-form-item
          v-if="isShowFormItem(f)"
          :key="f.prop"
          :prop="f.prop"
        >
          <template slot="label">
            <client-form-field-help
              :label="fieldLabel(f)"
              :help-key="fieldHelpKey(f)"
            />
          </template>
          <client-package-upload
            v-if="f.type === 'upload'"
            ref="pkgUpload"
            package-type="apk"
            param-key="apk_version_pro"
            accept=".apk"
            :tip="$tt('只能上传apk文件')"
            :before-select="beforeSelectFile"
            @change="fileChange"
          />
          <template v-else-if="f.type === 'radio'">
            <el-radio-group v-model="form[f.prop]">
              <el-radio
                v-for="item in formOptions[f.prop]"
                :key="item.value"
                :label="item.value"
                >{{ $tt(item.label) }}</el-radio
              >
            </el-radio-group>
          </template>
          <template v-else>
            <el-input
              v-model="form[f.prop]"
              :type="f.inputType || 'text'"
              :disabled="f.prop === 'name' && isEdit"
              :placeholder="$tt(f.placeholder)"
            ></el-input>
          </template>
        </el-form-item>
      </template>

      <el-form-item>
        <el-button type="primary" @click="submitForm">{{ $tt("确认保存") }}</el-button>
        <el-button @click="$router.push('/clientManage/apk')">{{ $tt("取消") }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ClientPackageUpload from "@/components/ClientPackageUpload.vue";
import ClientFormFieldHelp from "@/components/ClientFormFieldHelp.vue";
export default {
  components: { ClientPackageUpload, ClientFormFieldHelp },
  data() {
    return {
      form: this.initForm(),
      eidtableFormItems: [
        {
          prop: "file",
          label: "上传apk",
          type: "upload",
        },
        {
          prop: "name",
          label: "版本号",
          placeholder: "请输入",
        },
        {
          prop: "white_list_status",
          label: "白名单状态",
          placeholder: "请输入",
          type: "radio",
        },
        {
          prop: "white_list",
          label: "白名单设置",
          inputType: "textarea",
          placeholder: "设备唯一标识 以回车分隔",
        },
        {
          prop: "version_log",
          label: "更新日志",
          placeholder: "请输入",
          inputType: "textarea",
        },
        {
          prop: "status",
          label: "OTA 升级",
          type: "radio",
        },
        {
          prop: "catalog_show",
          label: "版本库展示",
          type: "radio",
        },
        {
          prop: "remark",
          label: "版本说明",
          placeholder: "请输入",
          inputType: "textarea",
        },
      ],
      formOptions: {
        white_list_status: [
          { label: "是", value: "true" },
          { label: "否", value: "false" },
        ],
        status: [
          { label: "是", value: "true" },
          { label: "否", value: "false" },
        ],
        catalog_show: [
          { label: "是", value: "true" },
          { label: "否", value: "false" },
        ],
      },
      formRules: {
        file: [{ required: true, message: `请选择文件`, trigger: "change" }],
        name: [{ required: true, message: `请输入版本号`, trigger: "blur" }],
        white_list_status: [
          { required: true, message: "请选择白名单状态", trigger: "blur" },
        ],
        white_list: [
          { required: true, message: "请输入白名单设置", trigger: "blur" },
        ],
        version_log: [
          { required: true, message: `请输入更新日志`, trigger: "blur" },
        ],
      },
      isEdit: false
    };
  },
  computed: {
    ...mapState([
      'loginAccountInfo'
    ]),
    isShowFormItem() {
      return (f) => {
        if (f.prop === 'white_list') {
          if (this.form.white_list_status !== 'true') {
            return false;
          }
        }
        if (f.type === 'upload') {
          if (this.isEdit) {
            return false;
          }
        }
        return true;
      }
    }
  },
  mounted() {
    this.getInitInfo();
  },
  methods: {
    ...mapActions(["findApkDataById", "saveApk", "updateApkData"]),
    fieldLabel(f) {
      return this.$tt(f.label);
    },
    fieldHelpKey(f) {
      if (f.prop === "file") {
        return "upload_apk";
      }
      return f.prop;
    },
    fileChange(file) {
      this.form.file = file ? [file] : [];
      this.$refs.form && this.$refs.form.validateField("file");
    },
    beforeSelectFile(file) {
      const name = (file && file.name) || "";
      if (!name.toLowerCase().endsWith(".apk")) {
        this.$message.error(this.$tt("只能上传apk文件"));
        return false;
      }
      return true;
    },
    initForm() {
      return {
        id: null,
        file: [],
        name: "",
        channel: "android",
        cpu_arch: "arm64",
        white_list_status: "false",
        white_list: "",
        version_log: "",
        status: "true",
        catalog_show: "true",
        remark: "",
      };
    },
    async getInitInfo() {
      const { id } = this.$route.query;
      if (!id) {
        this.isEdit = false;
        return;
      }
      this.isEdit = true;
      this.$changeLoadingState(true);
      const ret = await this.findApkDataById({ id });
      this.$changeLoadingState(false);
      if (ret && ret.status === "success") {
        const result = ret.data || {};
        Object.keys(this.form).forEach((key) => {
          if (result.hasOwnProperty(key)) {
            this.form[key] = result[key];
          }
        });
      } else {
        this.$message.error(ret && ret.msg);
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.isEdit) {
            // 修改接口
            this.$changeLoadingState(true);
            let params = {
              ...this.form
            };
            delete params.file;
            const ret = await this.updateApkData(params);
            this.$changeLoadingState(false);
            if (ret && ret.status === "success") {
              this.$router.push("/clientManage/apk");
            } else {
              this.$message.error(ret && ret.msg);
            }
          } else {
            const uploadRef = this.$refs.pkgUpload;
            const uploader = Array.isArray(uploadRef) ? uploadRef[0] : uploadRef;
            if (!uploader || !uploader.getFile()) {
              this.$message.error(this.$tt("请选择文件"));
              return;
            }
            this.$changeLoadingState(true);
            try {
              let params = { ...this.form };
              delete params.file;
              params.cpu_arch = "arm64";
              const ret = await uploader.upload(params);
              if (ret && ret.status === "success") {
                this.$router.push("/clientManage/apk");
              } else {
                this.$message.error(ret && ret.msg);
              }
            } catch (err) {
              this.$message.error((err && err.message) || this.$tt("上传失败"));
            } finally {
              this.$changeLoadingState(false);
            }
          }
        }
      });
    },
  },
};
</script>

<style lang='scss'>
.apk-form {
  background-color: #fff;
  padding: 24px 30% 24px 24px;
  .el-cascader--small {
    width: 100%;
  }
  .el-form-item__label {
    width: 30% !important;
  }
  .el-form-item__content {
    margin-left: 30% !important;
    .el-select {
      display: block;
    }
  }
}
.field-tip {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.5;
  color: #909399;
}

</style>